const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const AT = require("../../core/vault/ActionTypes");
const OrderSummary = require("./OrderSummary");
const Policies = require("../Policies");
const CheckoutUtil = require("./CheckoutUtil");

const AssetsUtil = require("../../core/util/AssetsUtil");
const OpsCart = require("../vault/OpsCart");

const styles = require("./styles/CompleteOrder.css");
const reviewOrderStyles = require("./styles/ReviewCart.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "ReviewClassWalletOrder",

		propTypes: {
			cart: PT.object.isRequired,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		classWalletContinue: function() {
			if (OpsCart.hasSubscriptionItems(this.props.cart.items)) {
				return;
			}
			this.props.dispatch({
				type: AT.CLASS_WALLET_SUBMIT_REQUEST,
			});
		},

		componentDidMount: function() {
			this.props.dispatch({
				type: AT.PREPARE_ORDER_REQUEST,
			});
		},

		renderBox: function(groups, title, section, tabIndex) {
			const allElems = [];
			let singleEl;
			let subtitleClass = styles.subtitle;
			if (groups.length === 1 && groups[0].length === 1) {
				// If there's only one line
				singleEl = <div className={styles.singleLine}>{groups[0][0]}</div>;
				subtitleClass = styles.subtitleSingle;
			} else {
				_.each(groups, (group, i) => {
					if (i > 0) allElems.push(<br key={"break" + i} />);
					_.each(group, elem => {
						allElems.push(elem);
					});
				});
			}

			return (
				<div className={styles.box} key={section + "Group"}>
					<div className={subtitleClass}>
						{title}
						{singleEl}
					</div>
					{allElems}
				</div>
			);
		},

		render: function() {
			const cart = this.props.cart;
			const needsShipping = OpsCart.needsShipping(cart);
			const infoGroups = CheckoutUtil.renderInfoGroupsCart(cart, {
				accountAsGroup: true,
			});

			const shippingInfoBox = this.renderBox(
				infoGroups[0],
				needsShipping ? "Shipping" : "Customer Address",
				needsShipping ? "shipping" : "customerAddress",
				1
			);

			const buttonContent = (
				<div className={reviewOrderStyles.classWalletButtonContainer}>
					<div className={reviewOrderStyles.classWalletText}>Continue With</div>
					<div
						className={reviewOrderStyles.classWalletContinue}
						onClick={this.classWalletContinue}
					>
						<img
							className={reviewOrderStyles.classWalletImg}
							src={AssetsUtil.getLogo("cw-logo-white", {
								extension: "png",
							})}
						/>
					</div>
				</div>
			);

			return (
				<div className={styles.main}>
					<div className={styles.title}>{"Review Information"}</div>
					<div className={styles.across}>
						<div className={styles.contentContainer}>
							<div className={styles.content}>
								{shippingInfoBox}
								<Policies
									cart={cart}
									includeTaxExemptInfo={true}
									className={styles.policyBox}
									titleClass={styles.policySubtitle}
									isClassWallet={true}
								/>
							</div>
						</div>
						<OrderSummary
							cart={this.props.cart}
							showItemize={true}
							hideFinalButtons={true}
							hidePaypalButton={true}
							buttonContent={buttonContent}
							tabIndex={3}
						/>
					</div>
				</div>
			);
		},
	})
);
